import { render, staticRenderFns } from "./edit-product.vue?vue&type=template&id=60f1ed64&"
import script from "./edit-product.vue?vue&type=script&lang=js&"
export * from "./edit-product.vue?vue&type=script&lang=js&"
import style0 from "./edit-product.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports